import { InMemoryCache } from '@apollo/client'

import { CommonStore } from 'modulesCommon/store'
import { ProductsStore } from 'modules/Products/store'
import { ProjectStore } from 'modules/Projects/store'
import { LabelsStore } from 'modules/Labels/store'
import { UsersStore } from 'modules/Users/store'
import { FeedStore } from 'modules/Feed/store'
import { ChartsStore } from 'modules/Charts/store'
import { TourDatesStore } from 'modules/TourDates/store'

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        ...CommonStore,
        ...ProductsStore,
        ...ProjectStore,
        ...LabelsStore,
        ...UsersStore,
        ...FeedStore,
        ...ChartsStore,
        ...TourDatesStore
      }
    }
  }
})
